const _FORM_TABS = [
    "Детайли на задачата",
    "Данни за клиента",
    "Приходи и Разходи",
    "Коментари",
    "Списък със завършени задачи",
]

export const CREATE_TABS = [];
CREATE_TABS[0] = _FORM_TABS[0];
CREATE_TABS[1] = _FORM_TABS[1];
CREATE_TABS[4] = _FORM_TABS[4];

//export const EDIT_TABS = _FORM_TABS.slice(0, -1);
export const EDIT_TABS = [
    ..._FORM_TABS
]
